import ValidationKeys from 'forms-utils-lib/constants/formField/ValidationKeys';
const defaultValidation = {
  [ValidationKeys.BLOCKED_EMAIL_ADDRESSES]: [],
  [ValidationKeys.DATA]: '',
  [ValidationKeys.MESSAGE]: '',
  [ValidationKeys.NAME]: '',
  [ValidationKeys.USE_DEFAULT_BLOCK_LIST]: false
};
export default defaultValidation;